import { Box } from '@mui/material'
import { styled } from '@mui/system'

const BoxWrapper = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '1.5em',
}))

const StyledBox = styled(Box)(() => ({
  backgroundColor: 'transparent !important',
  border: '1px solid rgba(0, 0, 0, 0.2) !important',
  boxShadow: 'none !important',
  padding: '1em 2em 0 2em',
  textAlign: 'center',
}))

const H1 = styled('h1')({
  margin: 0,
  fontSize: '16px',
})

const ServiceEndNotice = () => {
  return (
    <BoxWrapper>
      <StyledBox>
        <H1>【重要】</H1>
        <div>
          <p>「OCR Reader」 は2026年12月31日に提供を終了いたします</p>
          <p>
            長らくのご愛顧誠にありがとうございました。
            <br />
            今後は新サービス「PaperOn」のご利用をご検討ください。
          </p>
          <p>
            提供終了及びPaperOnに関する詳細は、下記をご覧ください。
            <br />
            <a
              href="https://mkt.line-works.com/LW-OCR-Reader_close_notice/"
              target="_blank"
              rel="noopener noreferrer"
            >
              OCR Reader提供終了及びPaperOnに関するご案内
            </a>
          </p>
        </div>
      </StyledBox>
    </BoxWrapper>
  )
}

export default ServiceEndNotice
